var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"alt":"Avatar Picture","src":require("../../assets/avatars/default.jpg")}})}
var staticRenderFns = []

export { render, staticRenderFns }